__turbopack_context__.v({
  "Container": "AV984W_Container",
  "Content": "AV984W_Content",
  "Header": "AV984W_Header",
  "HeaderWrapper": "AV984W_HeaderWrapper",
  "LoginButton": "AV984W_LoginButton",
  "Root": "AV984W_Root",
  "skeleton-loading": "AV984W_skeleton-loading",
});
